import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {decamelizeKeys} from 'humps'

export const unionSignContract = createAsyncThunk(
  'UnionSignUp/unionSignContract',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/union_sign_contract', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const unionUpdateSignContract = createAsyncThunk(
  'UnionSignUp/unionUpdateSignContract',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/union_edit_contract', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const unionSignInfo = createAsyncThunk(
  'UnionSignUp/unionSignInfo',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/union_sign_info', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export const sendEmailCode = createAsyncThunk(
  'UnionSignUp/sendEmailCode',
  async (p: any, store: any) => {
    const resp = await http.post('/live/account/get_code_by_email', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

interface initType {
  name?: string
  passport?: string
  id_card?: string
  email?: string
  i_dentity_pic?: string
  // eg: -1：未提交 0:提交审核;1:审核成功;2:审核被驳回
  review_status?: number
  editable?: 0 | 1 // 0 不可编辑
  settlement_type?: 0 | 1
  postal_code?: string
  user_street?: string
  user_city?: string
  user_province?: string
  user_country?: string
  user_name?: string
  bank_account_name?: string
  bank_account?: string
  i_ban?: string
  bank_swift_code?: string
  bank_name?: string
  bank_country?: string
  payoneer_i_d?: string
}

const initialState: initType = {}

const initData: initType = {
  name: '',
  passport: '',
  id_card: '',
  email: '',
  payoneer_i_d: '',
  i_dentity_pic: '',
  // eg: -1：未提交 0:提交审核;1:审核成功;2:审核被驳回
  review_status: -1,
  editable: 0,
  settlement_type: 0,
  postal_code: '',
}

export const UnionSignupSlice = createSlice({
  name: 'UnionSignup',
  initialState,
  reducers: {
    initData: (state) => {
      Object.assign(state, initData)
    },
  },
  extraReducers: (builder) => {
    builder.addCase(unionSignInfo.fulfilled, (state, action) => {
      const {data} = action.payload
      const newData = decamelizeKeys(data)
      Object.assign(state, {
        ...newData.info,
        editable: newData.editable,
        id_card: newData.info?.i_d_card,
      })
    })
    builder.addCase(unionSignContract.fulfilled, (state, action) => {
      Object.assign(state, {review_status: 0})
    })
  },
})

export default UnionSignupSlice.reducer

export const UnionSignupActions = UnionSignupSlice.actions
